import { authFetch } from "~/services/fetch";
import { AgencyResponse } from "../interface";

export async function getAgencies(): Promise<readonly AgencyResponse[]> {
  try {
    const { data } = await authFetch({
      url: '/agency',
      method: 'GET',
    })
    return data;
  } catch (error) {
    throw error;
  }
}